import React from "react";
import type { PropsWithChildren } from "react";

import { verticalProductCardHeader } from "./VerticalProductCard.css";

export const VerticalProductCardHeader: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={verticalProductCardHeader}>{children}</div>;
};
